/* Proper HiFi — "Buy now": add the selected variant + quantity to the cart, then go to checkout.
   Uses the same product form Horizon renders, so variant changes stay in sync. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ph-buy-now]');
    if (!button || button.disabled) return;
    event.preventDefault();
    var scope = button.closest('.shopify-section') || document;
    var form = scope.querySelector('form[data-type="add-to-cart-form"]') || scope.querySelector('form[action$="/cart/add"]');
    if (!form) return;
    var error = button.parentElement.querySelector('[data-ph-buy-now-error]');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    function fail(message) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (error) { error.textContent = message; error.hidden = false; }
    }
    if (error) { error.hidden = true; error.textContent = ''; }
    if (!idInput || !idInput.value) { fail('Please choose an option first.'); return; }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1) }] })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) { fail(result.data.description || result.data.message || 'We could not add this item. Please try again.'); return; }
        window.location.href = root + 'checkout';
      })
      .catch(function () { fail('Something went wrong. Please try again or call (330) 422-3991.'); });
  });
})();